import { api } from "./client";

export type ReasoningEffort =
  | "none"
  | "minimal"
  | "low"
  | "medium"
  | "high"
  | "xhigh";

export const REASONING_EFFORTS: ReasoningEffort[] = [
  "none",
  "minimal",
  "low",
  "medium",
  "high",
  "xhigh",
];

export interface ExtractionConfigSummary {
  id: string;
  name: string;
  version: number;
  enabled: boolean;
  model: string;
  reasoning_effort: ReasoningEffort;
  system_prompt: string;
  phone_fallback_prompt: string;
  verify_model: string;
  verify_reasoning_effort: ReasoningEffort;
  verify_text_limit: number;
  created_at: string | null;
  deleted_at: string | null;
}

export interface ExtractionConfigPayload {
  name: string;
  enabled: boolean;
  model: string;
  reasoning_effort: ReasoningEffort;
  system_prompt: string;
  phone_fallback_prompt: string;
  verify_model: string;
  verify_reasoning_effort: ReasoningEffort;
  verify_text_limit: number;
}

export interface GPTMetaView {
  model: string;
  requests: number;
  prompt_tokens: number;
  completion_tokens: number;
}

export interface ExtractionTestResponse {
  ok: boolean;
  lead: Record<string, unknown> | null;
  error: string | null;
  gpt_meta: GPTMetaView | null;
}

export const listExtractionConfigs = () =>
  api<ExtractionConfigSummary[]>("/api/extraction-configs");

export const getExtractionConfig = (id: string) =>
  api<ExtractionConfigSummary>(`/api/extraction-configs/${id}`);

export const createExtractionConfig = (body: ExtractionConfigPayload) =>
  api<{ id: string }>("/api/extraction-configs", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateExtractionConfig = (id: string, body: ExtractionConfigPayload) =>
  api<ExtractionConfigSummary>(`/api/extraction-configs/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const disableExtractionConfig = (id: string) =>
  api<ExtractionConfigSummary>(`/api/extraction-configs/${id}`, {
    method: "DELETE",
  });

export const validateExtractionConfig = (body: ExtractionConfigPayload) =>
  api<{ ok: boolean; summary: Record<string, unknown> }>(
    "/api/extraction-configs/validate",
    { method: "POST", body: JSON.stringify(body) },
  );

export const testExtractionConfig = (
  body: ExtractionConfigPayload,
  sampleImpressum?: string,
) =>
  api<ExtractionTestResponse>("/api/extraction-configs/test", {
    method: "POST",
    body: JSON.stringify({
      config: body,
      sample_impressum: sampleImpressum ?? null,
    }),
  });
